import { Maatregel } from "@/entities/vsm";

function hasStations(m: Maatregel): boolean {
    return Boolean(m.vanStationCode || m.naarStationCode);
}

/**
 * Regel van Marcel:
 * Toon maximaal 5 series met van/naar stations, of 10 series zonder van/naar station (of 4 met + 2 zonder, 3 met + 4 zonder, etc).
 * @param maatregelen
 */
export function determineMaxItems(maatregelen: Maatregel[]): number {
    const MAX_BUDGET = 10;
    const MET_WEIGHT = 2;

    const { count } = maatregelen.reduce(
        ({ count, budget }, maatregel) => {
            const weight = hasStations(maatregel) ? MET_WEIGHT : 1;
            const max = hasStations(maatregel) ? 5 : 10;
            const canAdd = budget >= weight && count < max;
            return {
                count: canAdd ? count + 1 : count,
                budget: canAdd ? budget - weight : budget,
            };
        },
        { count: 0, budget: MAX_BUDGET }
    );

    return count;
}
